module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_5_1-8df8f34edfafd85e963dee9c2d071975.webp";